import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const externalTestSessionLocaleModule: LocaleModule = {
  name: "externalTestSession",
  messages: { en: en, it: it },
};
